import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';

import { AdminDashboard } from './AdminDashboard';
import { FinancialAdvisorDashboard } from './FinancialAdvisorDashboard';
import { ScoutDashboard } from './ScoutDashboard';

export const Dashboard: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  if (hasAnyRole([Role.RoleAdmin])) {
    return <AdminDashboard />;
  } else if (hasAnyRole([Role.RoleFinancialAdvisor])) {
    return <FinancialAdvisorDashboard />;
  } else if (hasAnyRole([Role.RoleScout])) {
    return <ScoutDashboard />;
  }
  return null;
};
